export default __webpack_public_path__ + "static/media/Ambient, White.63f5fb51.png";